import repoAxios from "axios";

const accessToken = () => {
    // return window.tenantId;
    return window.access_token;
};

const authenticatedAxios = repoAxios.create({
    baseURL: window.api_url,
    headers: {
        'Authorization': `Bearer ${accessToken()}`,
        // 'tenant-id': window.tenantId
    }
});

authenticatedAxios.interceptors.request.use(function (config) {
    config.headers.Authorization = `Bearer ${accessToken()}`;
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

const axios = repoAxios.create({
    baseURL: window.api_url,
    headers: {
        // 'Tenant-Id': window.tenantId
    }
});

export { authenticatedAxios, axios };